import React from 'react'
import styled from 'styled-components'

const H2 = styled.h2`
  font-size: 1.5rem;
  padding: 0;
  display: inline-block;
  margin: 0;
  transform: skew(4deg);
  color: #333;
`

const Bkgd = styled.div`
  background: gold;
  transform: skew(-10deg);
  display: block;
  margin: 0 0 1rem -2.5rem;
  padding: 0 0.5rem;
`

export default ({ children }) => (
  <Bkgd>
    <H2>{children}</H2>
  </Bkgd>
)



// WEBPACK FOOTER //
// ./src/components/nav-title.js